import React from "react";
import { motion } from "framer-motion";

const textVariants = {
  hidden: { opacity: 0, x: -50 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

const styles = {
  container: {
    maxWidth: "900px",
    margin: "0 auto",
    padding: "20px",
    textAlign: "center",
    fontFamily: "Arial, sans-serif",
    color: "#333",
  },
  heading: {
    fontSize: "28px",
    fontWeight: "bold",
    marginBottom: "15px",
    color: "#5c0e14",
  },
  paragraph: {
    fontSize: "18px",
    lineHeight: "1.6",
    marginBottom: "15px",
    color: "#444",
  },
  responsive: {
    "@media (maxWidth: 768px)": {
      container: { padding: "15px" },
      heading: { fontSize: "24px" },
      paragraph: { fontSize: "16px" },
    },
    "@media (maxWidth: 480px)": {
      heading: { fontSize: "22px" },
      paragraph: { fontSize: "14px" },
    },
  },
};

const ArchitecturalExcellence = () => {
  return (
    <section style={styles.container}>
      <motion.h2
        style={styles.heading}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        Crafting Architectural Excellence Across Industries
      </motion.h2>

      {[
        "We believe that architecture is more than just buildings—it’s about creating functional, sustainable, and visually compelling environments that enhance the way people live and work.",
        "With decades of expertise, our firm has successfully delivered architectural, engineering, and interior design solutions across a wide range of industries, including residential, commercial, industrial, institutional, and hospitality sectors.",
        "Every project we undertake is driven by a commitment to sustainability, efficiency, and aesthetic excellence, ensuring long-lasting value and environmental responsibility.",
        "From modern commercial hubs to state-of-the-art industrial facilities, we shape structures that inspire and perform with excellence.",
      ].map((text, index) => (
        <motion.p
          key={index}
          style={styles.paragraph}
          variants={textVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {text}
        </motion.p>
      ))}
    </section>
  );
};

export default ArchitecturalExcellence;
